import { ADMIN_BOOKINGS_PATH, CUSTOMER_DASHBOARD_PATH } from "./notificationStorage";
import { isCustomerUser } from "./jwtRole";

/**
 * @param {import('../types/notification.types').ApiNotification} item
 */
export function mapApiNotificationToView(item) {
  const createdAt = item.createdAt
    ? new Date(item.createdAt).getTime()
    : Date.now();

  return {
    id: String(item.notificationId ?? item.recipientId),
    recipientId: item.recipientId,
    notificationId: item.notificationId,
    title: item.title || "Notification",
    message: item.message || "",
    read: Boolean(item.isRead),
    createdAt,
    link: resolveNotificationLink(item),
    notificationType: item.notificationType,
    referenceId: item.referenceId,
    referenceType: item.referenceType,
    redirectUrl: item.redirectUrl,
  };
}

/**
 * @param {import('../types/notification.types').ApiNotification} item
 */
function resolveNotificationLink(item) {
  if (item.notificationType === "ParcelBooking" || item.referenceType === "Parcel") {
    return isCustomerUser() ? CUSTOMER_DASHBOARD_PATH : ADMIN_BOOKINGS_PATH;
  }

  const url = item.redirectUrl;
  if (!url) return isCustomerUser() ? CUSTOMER_DASHBOARD_PATH : ADMIN_BOOKINGS_PATH;
  if (url.startsWith("http")) return url;
  if (url.startsWith("/admin-dashboard")) return url;
  if (url.startsWith("/user-dashboard")) return url;
  if (url.startsWith("/parcel")) return ADMIN_BOOKINGS_PATH;
  return url.startsWith("/") ? url : `/${url}`;
}

/**
 * @param {import('../types/notification.types').ApiNotification[]} items
 */
export function mapApiNotificationsToView(items) {
  return (items || []).map(mapApiNotificationToView);
}
